import { useMemo } from 'react'
import moment from 'moment'

import { DrawerBodyWrapper } from '@base'
import { Table } from '@baseV2'
import { strings } from '@constants'
import { displayName } from '@utils'

// opened from the history button of a vehicle on Edit Dispatch Plan: the delay status logs of the vehicle
const VehicleHistoryDrawer = ({ vehicle }) => {
	const logs = vehicle?.delay_status_logs ?? []

	const columns = useMemo(
		() => [
			{ label: strings('status'), key: 'status', default: '-', mobile: true },
			{
				label: strings('created_at'),
				key: 'created_at',
				renderer: (data) => (data ? moment(data).format('DD MMM YYYY, hh:mm A') : '-'),
				mobile: true,
			},
			{
				label: strings('updated_by'),
				key: 'updated_by',
				renderer: (data) => displayName(data) || '-',
				mobile: true,
			},
		],
		[]
	)

	return (
		<DrawerBodyWrapper>
			<Table
				columns={columns.map((col) => ({ ...col, sortable: false }))}
				data={logs}
				rowsToDisplay={logs.length || 1}
				totalItemCount={logs.length}
				onPageChange={() => {}}
				rowClickable={false}
				hideFooter
				emptyState={{ text: strings('no_data_found') }}
			/>
		</DrawerBodyWrapper>
	)
}

export default VehicleHistoryDrawer
